/**
 * OPS-STAB-003 — lightweight queue keyboard navigation (shared logic).
 */
import { EXECUTION_KEYS } from './operationalKeyboard.js';
import { isTypingTarget } from './keyboardStandards.js';
import { scrollQueueRowIntoView } from './executionUx.js';

/**
 * Pure reducer for queue index movement.
 */
export function nextQueueIndex(current, length, direction) {
  if (length <= 0) return -1;
  if (current < 0) return 0;
  if (direction > 0) return Math.min(current + 1, length - 1);
  return Math.max(current - 1, 0);
}

/**
 * Handle queue navigation key — returns new index or -1 if unhandled.
 */
export function handleQueueKeydown(e, { activeIndex, length, selectAt }) {
  if (length <= 0) return activeIndex;
  if (isTypingTarget(e.target)) return activeIndex;

  if (e.key === EXECUTION_KEYS.QUEUE_DOWN) {
    e.preventDefault();
    const next = nextQueueIndex(activeIndex, length, 1);
    selectAt?.(next);
    scrollQueueRowIntoView(next);
    return next;
  }
  if (e.key === EXECUTION_KEYS.QUEUE_UP) {
    e.preventDefault();
    const next = nextQueueIndex(activeIndex, length, -1);
    selectAt?.(next);
    scrollQueueRowIntoView(next);
    return next;
  }
  if (e.key === EXECUTION_KEYS.NEXT_ACTION && activeIndex >= 0) {
    e.preventDefault();
    selectAt?.(activeIndex);
    return activeIndex;
  }
  return activeIndex;
}
